import { Observable } from 'rxjs';

import { UnitResult } from '../../../../error';
import { JobRate } from '../../Model/Job/VO/job-rate';
import { EstimateJobRequest } from './estimate-job-request.model';

/**
 * Abstract service responsible for estimating the hourly rate for a job.
 *
 * This service provides a method to calculate the hourly rate based on the
 * details provided in the `EstimateJobRequest` model. The implementation of
 * this service must define the logic to generate a `JobRate` encapsulated
 * within an observable `UnitResult`.
 *
 * A note: the server returns already doubled rate if the job is urgent
 *
 * @abstract
 */
export abstract class EstimateJobHourlyRateService {
    abstract execute(model: EstimateJobRequest): Observable<UnitResult<JobRate>>;
}
